import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import LabForm from '../../../components/LabForm/LabForm';
import * as actions from '../../../store/labTests/actions';

function EditLab() {
  const connectedUser = useSelector((state) => state.auth?.user?.data);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { labTest } = useSelector(state => state.labTests);

  useEffect(() => {
    if (id) {
      dispatch(actions.getLabTestRequest(id));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  if (connectedUser?.role_id !== 1 && connectedUser?.role_id !== 4 && connectedUser?.role_id !== 6) {
    return "Your are not authorized to view this page";
  }

  return (
    <div>
        <LabForm lab={labTest} />
    </div>
  );
}

export default EditLab;
